const EXPIRE_DAYS_WARNING = 14;
export const ONE_HOUR = 1000 * 60 * 60;
export const ONE_DAY = ONE_HOUR * 24;

const getDestinationExpireDate = (expiresOn?: string) => {
  const expireDate = new Date(expiresOn || Date.now());
  const isNeverExpire = isNaN(expireDate.getTime());

  if (isNeverExpire) return null;

  const now = new Date();
  const hoursToExpire = Math.round((expireDate.getTime() - now.getTime()) / ONE_HOUR);

  const daysToExpire = Math.round((hoursToExpire === 0 ? 1 : hoursToExpire) / 24);

  return {
    daysToExpire,
    hoursToExpire,
    isWarning: daysToExpire < EXPIRE_DAYS_WARNING
  };
};

export default getDestinationExpireDate;
